<h2 mat-dialog-title>{{ 'QUERY_ICON_PICKER_TITLE' | transloco }}</h2>

<mat-dialog-content>
  <mat-form-field appearance="outline" class="search-field">
    <mat-label>{{ 'QUERY_ICON_SEARCH' | transloco }}</mat-label>
    <mat-icon matPrefix>search</mat-icon>
    <input matInput [(ngModel)]="search" autocomplete="off" spellcheck="false" />
  </mat-form-field>

  <p class="count-hint">{{ filtered.length }} icône(s)</p>

  <div class="icon-grid">
    @for (icon of filtered; track icon) {
      <button
        type="button"
        class="icon-cell"
        [class.selected]="selected() === icon"
        [matTooltip]="icon"
        matTooltipShowDelay="600"
        (click)="select(icon)"
      >
        <mat-icon>{{ icon }}</mat-icon>
        <span class="icon-name">{{ icon }}</span>
      </button>
    }

    @if (filtered.length === 0) {
      <p class="no-result">{{ 'QUERY_ICON_NO_RESULT' | transloco }}</p>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="clear()">{{ 'QUERY_ICON_REMOVE' | transloco }}</button>
  <button mat-button type="button" (click)="dialogRef.close()">{{ 'CANCEL' | transloco }}</button>
  <button mat-flat-button color="primary" type="button" [disabled]="!selected()" (click)="confirm()">
    {{ 'APPLY' | transloco }}
  </button>
</mat-dialog-actions>
